/* AFTER FOUR v52 Shop All: shelf browse, mood filters, price/name sorting, authentic media and live pack variants. */
(() => {
  'use strict';
  const validFilters = new Set(['all','makhana','edamame','spicy','creamy','classic']);
  const filterFromUrl = () => {
    const value = new URLSearchParams(window.location.search).get('af_filter');
    return validFilters.has(value) ? value : 'all';
  };
  const syncUrl = (filter, jump = false) => {
    const url = new URL(window.location.href);
    if (filter === 'all') url.searchParams.delete('af_filter');
    else url.searchParams.set('af_filter', filter);
    if (jump) url.hash = 'af52-products';
    const destination = url.pathname + url.search + url.hash;
    if (destination !== window.location.pathname + window.location.search + window.location.hash) {
      window.history.pushState({af52Filter:filter},'',destination);
    }
  };
  const browseProducts = (shop) => shop.querySelector('#af52-products')?.scrollIntoView({
    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    block: 'start'
  });
  const boot = (root = document) => {
    root.querySelectorAll('[data-af52-shop]').forEach((shop) => {
      if (shop.dataset.af52Ready === 'true') return;
      shop.dataset.af52Ready = 'true';
      const grid = shop.querySelector('[data-af52-grid]');
      const cards = [...shop.querySelectorAll('[data-af52-card]')];
      const chips = [...shop.querySelectorAll('[data-af52-filter]')];
      const shelves = [...shop.querySelectorAll('[data-af52-shelf]')];
      const count = shop.querySelector('[data-af52-count]');
      const sort = shop.querySelector('[data-af52-sort]');
      const browse = shop.querySelector('#af52-products');
      let activeFilter = 'all';
      const getPrice = (card) => Number(card.dataset.price || 0);
      const productFits = (card, filter) =>
        filter === 'all' || card.dataset.kind === filter || card.dataset.mood === filter;
      const setFilter = (filter) => {
        activeFilter = filter;
        let visible = 0;
        cards.forEach((card) => {
          card.hidden = !productFits(card, filter);
          if (!card.hidden) visible += 1;
        });
        if (count) count.textContent = 'SHOWING ' + visible + ' ' + (visible === 1 ? 'FLAVOUR' : 'FLAVOURS');
        chips.forEach((chip) => {
          const active = chip.dataset.af52Filter === filter;
          chip.classList.toggle('is-active', active);
          chip.setAttribute('aria-pressed', String(active));
        });
        shelves.forEach((shelf) => {
          const active = shelf.dataset.af52Shelf === filter;
          shelf.classList.toggle('is-selected', active);
          shelf.setAttribute('aria-pressed', String(active));
        });
      };
      const doSort = () => {
        if (!grid) return;
        const mode = sort?.value || 'featured';
        [...cards].sort((a, b) => {
          if (mode === 'price-low') return getPrice(a) - getPrice(b) || Number(a.dataset.index) - Number(b.dataset.index);
          if (mode === 'price-high') return getPrice(b) - getPrice(a) || Number(a.dataset.index) - Number(b.dataset.index);
          if (mode === 'name') return a.dataset.name.localeCompare(b.dataset.name);
          return Number(a.dataset.index) - Number(b.dataset.index);
        }).forEach(card => grid.appendChild(card));
      };
      chips.forEach((chip) => chip.addEventListener('click', () => {
        const filter = chip.dataset.af52Filter;
        setFilter(filter);
        syncUrl(filter);
      }));
      shelves.forEach((shelf) => shelf.addEventListener('click', () => {
        const filter = shelf.dataset.af52Shelf;
        setFilter(filter);
        syncUrl(filter, true);
        browseProducts(shop);
      }));
      if (sort) sort.addEventListener('change', doSort);
      shop.addEventListener('click', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        const toggle = target.closest('[data-af52-flip]');
        if (toggle && shop.contains(toggle)) {
          const card = toggle.closest('[data-af52-card]');
          const first = card?.querySelector('[data-af52-front]');
          const second = card?.querySelector('[data-af52-more]');
          if (!first || !second) return;
          const isMore = toggle.getAttribute('aria-pressed') !== 'true';
          first.hidden = isMore;
          second.hidden = !isMore;
          toggle.setAttribute('aria-pressed', String(isMore));
          toggle.textContent = isMore ? 'FRONT PACK ↻' : 'MORE PHOTOS ↻';
          return;
        }
        const variant = target.closest('[data-af52-variant]');
        if (!variant || variant.disabled || !shop.contains(variant)) return;
        const card = variant.closest('[data-af52-card]');
        if (!card) return;
        card.querySelectorAll('[data-af52-variant]').forEach((button) => {
          const active = button === variant;
          button.classList.toggle('is-selected', active);
          button.setAttribute('aria-pressed', String(active));
        });
        const variantInput = card.querySelector('input[name="id"]');
        if (variantInput) variantInput.value = variant.dataset.id;
        const amount = card.querySelector('[data-af52-money]');
        if (amount) amount.textContent = variant.dataset.money;
        const note = card.querySelector('[data-af52-pack-text]');
        if (note) {
          const size = card.dataset.size || '50';
          const savings = variant.dataset.save;
          note.textContent = variant.dataset.pack + ' × ' + size + ' G' + (savings ? ' · SAVE ' + savings : '');
        }
        card.dataset.price = variant.dataset.price;
        if (sort && (sort.value === 'price-low' || sort.value === 'price-high')) doSort();
      });
      setFilter(filterFromUrl());
      window.addEventListener('popstate', () => setFilter(filterFromUrl()));
      shop.addEventListener('af52:header-filter', (event) => {
        const kind = event.detail?.filter;
        if (kind !== 'makhana' && kind !== 'edamame') return;
        setFilter(kind);
        syncUrl(kind, true);
        browseProducts(shop);
      });
    });
  };

  // V52-only adaptation of shared Shopify menus. Nothing changes in Shopify's live Navigation menu.
  const kindFromUrl = (href) => {
    if (!href) return null;
    let url;
    try { url = new URL(href, window.location.href); } catch (_) { return null; }
    if (url.origin !== window.location.origin) return null;
    const path = url.pathname.endsWith('/') ? url.pathname.slice(0, -1) : url.pathname;
    if (path === '/collections/roasted-makhana') return 'makhana';
    if (path === '/collections/roasted-edamame') return 'edamame';
    if (path === '/collections/all') {
      const filter = url.searchParams.get('af_filter');
      return filter === 'makhana' || filter === 'edamame' ? filter : null;
    }
    return null;
  };
  const shopAllDestination = (kind, oldHref) => {
    const destination = new URL('/collections/all', window.location.origin);
    const old = new URL(oldHref,window.location.href);
    const previewId = old.searchParams.get('preview_theme_id') ||
      new URLSearchParams(window.location.search).get('preview_theme_id');
    if (previewId) destination.searchParams.set('preview_theme_id', previewId);
    destination.searchParams.set('af_filter',kind);
    destination.hash = 'af52-products';
    return destination.pathname + destination.search + destination.hash;
  };
  const rewriteNavigation = () => {
    const header = document.querySelector('#header-group');
    if (!header) return;
    header.querySelectorAll('a[href]').forEach((anchor) => {
      const kind = kindFromUrl(anchor.getAttribute('href'));
      if (!kind) return;
      anchor.dataset.af52HeaderFilter = kind;
      const next = shopAllDestination(kind,anchor.getAttribute('href'));
      if (anchor.getAttribute('href') !== next) anchor.setAttribute('href',next);
    });
  };
  let headerObserver = null;
  const initialize = (root = document) => {
    boot(root);
    rewriteNavigation();
    const header = document.querySelector('#header-group');
    if (header && !headerObserver) {
      headerObserver = new MutationObserver(rewriteNavigation);
      headerObserver.observe(header,{childList:true,subtree:true});
    }
  };
  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const link = target?.closest('#header-group a[href]');
    if (!link) return;
    const kind = link.dataset.af52HeaderFilter || kindFromUrl(link.getAttribute('href'));
    if (kind !== 'makhana' && kind !== 'edamame') return;
    const next = shopAllDestination(kind,link.getAttribute('href'));
    if (link.getAttribute('href') !== next) link.setAttribute('href',next);
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const shop = document.querySelector('[data-af52-shop]');
    if (!shop) return;
    event.preventDefault();
    shop.dispatchEvent(new CustomEvent('af52:header-filter',{detail:{filter:kind}}));
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once:true});
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target || document));
})();